<div class="row">
  <div class="col text-right">
    <div>
      <span kendoTooltip position="left" [tooltipTemplate]="kInformationTemplatebp2" title="kInformationTemplatebp2" class="k-icon k-i-information k-i-info build_and_buy"></span>
    </div>
  </div>
</div>
<div *ngIf="configError.length>0" style="padding: 10px; border-radius: 5px; color: red;">
  {{configError}}
</div>
<div *ngIf="productModel?.erros?.length>0" style="padding:10px;border-radius:5px;">
  <div *ngFor="let msg of productModel?.erros" style="color:red;">
    {{msg}} <br />
  </div>
</div>
<div *ngIf="productModel.v6SummaryMessage.length>0" style="padding:10px;background-color:lightblue;border-radius:5px;">
  <div *ngFor="let msg of productModel.v6SummaryMessage">
    {{msg}} <br />
  </div>
</div>
<kendo-tabstrip (tabSelect)="onTabSelect($event)">
  <kendo-tabstrip-tab [selected]="true">
    <ng-template kendoTabTitle>
      General
      <span class="k-icon k-i-cancel" style="color:red;font-weight:300;padding-left: 15px;padding-top:1px;"
            *ngIf="generalTabError"></span>
      <span class="k-icon k-i-check-circle k-i-checkmark-circle"
            *ngIf="generalTabClicked && !generalTabError"
            style="color: green;font-weight: 600;padding-left: 15px;padding-top:1px;"></span>
      <span class="k-icon k-i-question"
            *ngIf="!generalTabClicked && !generalTabError"
            style="color: blue;font-weight: 600;padding-left: 15px;padding-top:1px;"></span>
    </ng-template>
    <ng-template kendoTabContent>
      <div class="product-config-container-row">
        <div class="product-config-container-col">
          <div class="form-group attr-width">
            <div class="form-group attr-width">
              <label for="productReference ">Product Reference</label>
              <input type="text"
                     class="form-control"
                     id="productReference"
                     name="productReference"
                     maxlength=16
                     [disabled]="configCreationInProgres"
                     [(ngModel)]="productModel.reference">
            </div>
            <div class="form-group attr-width">
              <label for="productQuantity">Quantity</label>
              <input type="text"
                     class="form-control"
                     id="productQuantity"
                     name="productQuantity"
                     [disabled]="configCreationInProgres"
                     [(ngModel)]="productModel.quantity">

            </div>
            <div *ngFor="let attrs of productModel?.productAttributes;let attrIndex=index">
              <app-test-attr-c [attrs]="attrs" [disabled]="configCreationInProgres"
                               (attrChange)="executeMacro(attrs)"></app-test-attr-c>
            </div>
            <hr />
            <ul *ngFor="let err of productErrors " class="error-list">
              <li style="color: red;">{{err.errorMessage}}</li>
            </ul>
          </div>
        </div>
      </div>
    </ng-template>
  </kendo-tabstrip-tab>
  <kendo-tabstrip-tab *ngIf="productModel?.resourceFrame?.frameName?.length>0">
    <ng-template kendoTabTitle>
      {{productModel.resourceFrame.frameName}}
      <span class="k-icon k-i-cancel" style="color:red;font-weight:300;padding-left: 15px;padding-top:1px;"
            *ngIf="productModel.resourceFrame.isError"></span>
      <span class="k-icon k-i-check-circle k-i-checkmark-circle"
            *ngIf="productModel.resourceFrame.clicked && !productModel.resourceFrame.isError"
            style="color: green;font-weight: 600;padding-left: 15px;padding-top:1px;"></span>
      <span class="k-icon k-i-question"
            *ngIf="!productModel.resourceFrame.clicked && !productModel.resourceFrame.isError"
            style="color: blue;font-weight: 600;padding-left: 15px;padding-top:1px;"></span>
    </ng-template>

    <ng-template kendoTabContent>
      <div class="product-config-container-col" *ngFor="let attrC of productModel.resourceFrame.attributeFiltersForUI;let attrCIndex=index">
        <div class="product-config-container-row" *ngFor="let attrs of attrC;let attrIndex=index">
          <app-test-attr-c [attrs]="attrs" [disabled]="configCreationInProgres"
                           (attrChange)="executeMacro(attrs)"></app-test-attr-c>
        </div>
      </div>
      <hr />
      <ul *ngFor="let err of resourceFrameErrors" class="error-list">
        <li style="color: red;">{{err.errorMessage}}</li>
      </ul>
    </ng-template>
  </kendo-tabstrip-tab>
  <ng-container *ngIf="1===1">
    <kendo-tabstrip-tab *ngFor="let nestFrame of productModel.nestedFrames;let i=index;">
      <ng-template kendoTabTitle>
        {{nestFrame.frameName}}
        <span class="k-icon k-i-cancel" style="color:red;font-weight:300;padding-left: 15px;padding-top:1px;"
              *ngIf="nestFrame.isError"></span>
        <span class="k-icon k-i-check-circle k-i-checkmark-circle"
              *ngIf="nestFrame.clicked && !nestFrame.isError"
              style="color: green;font-weight: 600;padding-left: 15px;padding-top:1px;"></span>
        <span class="k-icon k-i-question"
              *ngIf="!nestFrame.clicked && !nestFrame.isError"
              style="color: blue;font-weight: 600;padding-left: 15px;padding-top:1px;"></span>
      </ng-template>
      <ng-template kendoTabContent>
        <div class="product-config-container-col" *ngFor="let attrC of nestFrame.attributeFiltersForUI;let attrCIndex=index">
          <ng-container *ngFor="let attrs of attrC;let attrIndex=index">
            <div *ngIf="attrs.show" class="product-config-container-row">
              <!--<div class="form-group attr-width">-->
              <app-test-attr-c [attrs]="attrs"
                               [disabled]="configCreationInProgres"
                               (attrChange)="executeMacro(attrs)"></app-test-attr-c>
              <!--</div>-->
            </div>
          </ng-container>
        </div>
        <div *ngIf="productModel.nestedFrames.length>1">
          <hr />
          Copy settings from
          <select #selectedFromIndex name="selectedFromIndex">
            <option value="-1"></option>
            <ng-container *ngFor="let f of  productModel.nestedFrames;let fIndex=index;">
              <ng-container *ngIf="fIndex!==i">
                <option value="{{fIndex}}">{{fIndex+1}}</option>
              </ng-container>
            </ng-container>
          </select>
          <button class="m-3 clearKendoButton btn btn-success"
                  (click)="copySettings(i,selectedFromIndex?.value)"
                  kendoButton>
            Copy
          </button>
        </div>
        <hr />
        <ul *ngFor="let err of nestedFrameErrors[i]">
          <li style="color: red;">{{err.errorMessage}}</li>
        </ul>
      </ng-template>
    </kendo-tabstrip-tab>
  </ng-container>
</kendo-tabstrip>
<div class="text-center">
  <button class="m-3 clearKendoButton btn btn-success"
          *ngIf="showBackBtn()"
          (click)="goBack()"
          [disabled]="configCreationInProgres"
          kendoButton>
    Back
  </button>
  <button class="m-3 clearKendoButton btn btn-success"
          (click)="submitConfiguration(false)"
          [disabled]="configCreationInProgres"
          kendoButton>
    Continue<kendo-loader *ngIf="configCreationInProgres" style="color:blue"></kendo-loader>
  </button>
</div>

<section>
  <ng-template #kInformationTemplatebp2 let-kInformationTemplateAnchorbp2>
    <div lass="text-white-50 bg-dark">
      <ol>
        <li>Select each tab to view/change applicable options for your item</li>
        <li>Required menu selections will be noted as ‘Please Select’ (not all fields are required)</li>
        <li> Clicking ‘Continue’ will run size & hardware validations for the current product and selections</li>
        <li>If validation errors are found, a red X will appear on the associated tab requiring updates (click ‘Continue’ after updates are made)</li>
        <li> If no validation errors are found, you will proceed to the confirmation screen</li>
      </ol>
    </div>
  </ng-template>
</section>
